// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    POST_FINITE_LOADING() {
      return {
        isLoading: true,
        postFinite: action.postFinite
      };
    },
    POST_FINITE_LOADED() {
      return {
        isLoading: false,
        data: action.postFinite
      };
    },
    POST_FINITE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postFinite.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
